import { useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";

export default function SearchBox({
  variant = "navbar",
  initialValue = "",
  className = "",
}: {
  variant?: "navbar" | "inline";
  initialValue?: string;
  className?: string;
}) {
  const navigate = useNavigate();
  const [value, setValue] = useState(initialValue);

  const submit = (e: FormEvent) => {
    e.preventDefault();
    const keyword = value.trim();
    if (!keyword) {
      navigate("/news");
      return;
    }
    navigate(`/news?q=${encodeURIComponent(keyword)}`);
  };

  const isNavbar = variant === "navbar";

  return (
    <form
      onSubmit={submit}
      role="search"
      className={`flex items-center rounded-full border transition-colors ${
        isNavbar
          ? "border-background-300 bg-background-100 focus-within:border-primary-400 focus-within:bg-background-50"
          : "border-background-300 bg-background-50 focus-within:border-primary-400"
      } ${className}`}
    >
      <span
        className={`flex items-center justify-center pl-3 text-foreground-500 ${
          isNavbar ? "h-9 w-9" : "h-11 w-11"
        }`}
      >
        <i className="ri-search-line text-base" />
      </span>
      <input
        type="search"
        name="site-search"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder="搜索新闻或作品关键词"
        aria-label="全站搜索"
        className={`min-w-0 flex-1 bg-transparent text-sm text-foreground-900 placeholder:text-foreground-500 focus:outline-none ${
          isNavbar ? "py-2" : "py-3"
        }`}
      />
      <button
        type="submit"
        className={`mr-1 flex items-center justify-center rounded-full bg-primary-500 text-background-50 transition-colors hover:bg-primary-600 ${
          isNavbar ? "h-7 w-7" : "h-9 w-9"
        }`}
        aria-label="搜索"
      >
        <i className="ri-arrow-right-line text-sm" />
      </button>
    </form>
  );
}